<div class="map">
  <bom-sted-map
    [stedOplysninger$]="stedOplysninger$"
    [konfliktLayers$]="konfliktLayers$"
    [enableMeasurement]="enableMeasurement"
    [padding]="[220, 165, 165, 400]"
    [showGoToAddressDetailsButton]="false"
  >
    <ng-container map-overlay-bottom>
      <div class="konflikt-container">
        <ng-container *ngIf="konfliktTyperWithConflicts$ | async as konfliktTyperWithConflicts">
          <div class="layer-container" *ngIf="konfliktTyperWithConflicts.length > 0">
            <ng-container *ngFor="let konfliktType of konfliktTyperWithConflicts">
              <ng-container
                *ngTemplateOutlet="
                  konfliktTypeTemplate;
                  context: { konfliktType: konfliktType, type: 'conflict' }
                "
              ></ng-container>
            </ng-container>
          </div>
        </ng-container>
        <div
          class="row all-layers-header"
          tabindex="0"
          (click)="toggleOtherLayers()"
          *ngIf="(otherKonfliktTyper$ | async)?.length > 0"
        >
          <div class="col col-9">Øvrige kortlag</div>
          <div class="col col-3 align-right">
            <svg class="icon-svg mr-3">
              <use xlink:href="#chevron-right" *ngIf="showOtherLayers"></use>
              <use xlink:href="#angle-arrow-down" *ngIf="!showOtherLayers"></use>
            </svg>
          </div>
        </div>
        <ng-container *ngIf="showOtherLayers">
          <div class="layer-container" *ngIf="otherKonfliktTyper$ | async as otherKonfliktTyper">
            <ng-container *ngFor="let konfliktType of otherKonfliktTyper">
              <ng-container
                *ngTemplateOutlet="
                  konfliktTypeTemplate;
                  context: { konfliktType: konfliktType, type: 'other' }
                "
              ></ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </bom-sted-map>
</div>

<ng-template #konfliktTypeTemplate let-konfliktType="konfliktType" let-type="type">
  <div class="row layer" [class.layer-conflict]="type === 'conflict'">
    <div class="col col-2 col-icon">
      <ng-container *ngIf="type !== 'other'" [ngSwitch]="konfliktType.status">
        <svg *ngSwitchCase="'Conflict'" class="icon-svg conflict-color">
          <use xlink:href="#warning-filled"></use>
        </svg>
        <svg *ngSwitchCase="'Pseudo'" class="icon-svg pseudo-color">
          <use xlink:href="#warning-filled"></use>
        </svg>
        <svg *ngSwitchCase="'Inconclusive'" class="icon-svg inconclusive-color">
          <use xlink:href="#error-filled"></use>
        </svg>
        <svg *ngSwitchCase="'NoConflict'" class="icon-svg inconclusive-color">
          <use xlink:href="#warning-filled"></use>
        </svg>
      </ng-container>
    </div>
    <div class="col konflikt-title">{{ konfliktType.kort.visningNavn }}</div>
    <div class="col col-auto align-right">
      <div class="form-group">
        <input
          [id]="'layer-' + konfliktType.kort.kode"
          type="checkbox"
          [name]="'layer-' + konfliktType.kort.visningNavn"
          [checked]="!!checkedLayers[konfliktType.kort.kode]"
          (change)="setLayerVisible($event.target.checked, konfliktType.kort.kode)"
          class="form-checkbox"
        />
        <label [for]="'layer-' + konfliktType.kort.kode"></label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col offset-2 col-10">
      <img
        *ngIf="!!checkedLayers[konfliktType.kort.kode]"
        [src]="konfliktType.kort.signaturForklaringUrl"
      />
    </div>
  </div>
</ng-template>
